import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appResponsiveBreakpoint]',
  standalone: true,
})
export class ResponsiveBreakpointDirective {
  @Input() screen: string;

  constructor(public element: ElementRef) {}
}
